<template functional>
  <ul class="d-flex flex-wrap list-unstyled" v-if="props.entries.length">
    <li v-for="entry in props.entries" :key="entry.entryId" class="m-3">
      <slot :entry="entry">
        {{ entry }}
      </slot>
    </li>
  </ul>
  <div v-else class="text-center text-secondary">
    <div class="folder-empty-thumbnail" />
    <p>
      ファイルがありません
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style>
.folder-empty-thumbnail {
  height: 10rem;
  margin-bottom: 2.5rem;
  background-repeat: no-repeat;
  background-size: 100px;
  background-position: bottom;
}
</style>
